<template>
	<div id="panel-4" class="panel">
		<div class="panel-hdr ">
			<h2>
				{{__t('LIST')}} <span class="fw-300"><i>{{__t('CATEGORIES')}}</i></span>
			</h2>

			<div class="panel-toolbar">
				<button class="btn btn-icon btn-sm btn-success mr-1 shadow-0 waves-effect waves-themed" v-on:click="create">
					<i class="fal fa-plus"></i>
				</button>

                <button class="btn btn-icon  btn-sm btn-info  shadow-0  waves-effect waves-themed mr-2"  v-on:click="remove_skip_sync">
                    <i class="fal fa-money-check-edit-alt"></i>
                </button>

			</div>
		</div>
		<div class="panel-container show pt-5 pb-5">
			<div class="panel-content">
				<b-overlay :show="is_load" rounded="sm">
					<div class="rounded">
                        <categ_node :categories="worked_categs" v-if="worked_categs.length > 0"></categ_node>
						<div class="filter-message js-filter-message m-0 text-left pl-4 py-3 fw-500"></div>
					</div>
				</b-overlay>
			</div>
		</div>
		<categ_modal></categ_modal>
	</div>
</template>

<script>
import Categ_modal from "./category/categ_modal.vue";
import categ_node from "./sub/categ_node";


import {createHelpers} from 'vuex-map-fields';
import {mapGetters} from "vuex";


const {mapFields} = createHelpers({
	getterType: 'inbox_state/getInboxStateField',
	mutationType: 'inbox_state/updateInboxStateField',
});


export default {
	name: "categories",
	components: {Categ_modal,categ_node},
	data() {
		return {
			categories: [],
			is_load: true,
			is_show_modal: false,
		}
	},

	created() {
		this.get_params();
		EventBus.$on('reload_categories',this.get_params)
	},

	methods: {
        remove_skip_sync() {
            const is_ok = confirm_me(this.__t("REMOVE_SKIP_SYNC_ATTRIBUTES"));
            is_ok.then(res => {
                api.delete('/internal/v1/catalog/categories/sync_flag').then(({data}) => {
                    if (data.status === "operation_success") {
                        this.get_params();
                    }
                }).catch(({response}) => {
                    EventBus.$emit('show_toast', {
                        err: response.data.message, type: "danger",
                        title: response.data.status,
                        position : "b-toaster-top-left"
                    })
                });
            });
        },

		create() {
            EventBus.$emit("categ_edit", 0);
		},

		async get_params() {
			this.categories = [];
			this.is_load = true;

			await api.get('/internal/v1/catalog/categories/tree').then(({data}) => {
				this.is_load = false;
				if (data.status === "operation_success") {
					this.categories = data.data;
				}

			}).catch(({response}) => {
				this.is_load = false;
				this.categories = [];
				EventBus.$emit('show_toast', {
				    err: response.data.message, type: "danger",
                    title: response.data.status,
                    position : "b-toaster-top-left"
				})
			});
		}
	},

	computed: {
		...mapGetters({
			'user': "user/getUser",
		}),

		...mapFields([
			'all_filter',
			'filter'
		]),

		active_org_id () {
			if (this.all_filter.hasOwnProperty('org_id')) {
				return this.all_filter.org_id;
			}

			return 0;
		},
        worked_categs() {
			if(parseInt(this.active_org_id) > 0) {
				return this.categories.filter(item => {return parseInt(item.restaurant_id) === parseInt(this.active_org_id) });
			}
			else {
				return this.categories;
			}
		},

		all_catges() {
			let res = [];
			this.categories.map(item => {
				res.push(item);
				if (item.children.length > 0) {
					item.children.map(child => {
						res.push(child);
					});
				}
			});

			return res;
		},

		active_categories() {
			return this.all_catges.filter(item => {
				return item.is_active;
			})
		}
	}
}
</script>

<style scoped>
.categ_bg {
	background-color: #eeeeee2e;
}

.children_info {
	width: 15px;
	height: 15px;
	cursor: row-resize;
	text-align: center;
}

a.active_filter {
	border-left: 3px solid #584475;
	background: #eee;
}

li.show_children ul {
	display: block;
}

</style>
